import { TDevice } from '$constants/devices'

export const SIZE = 20

export const ID = 'device'

export type Namespaces = TDevice
